import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "./Subservicesmediacarousel.css";

const MedicalCareCarousel = ({ title, services }) => {
  return (
    <div className="Subservices-media-carousel-container">
      {title && (
        <h2 className="Subservices-media-carousel-title">{title}</h2>
      )}

      <Swiper
        modules={[Autoplay]}
        loop={true}
        autoplay={{
          delay: 0,
          disableOnInteraction: false,
        }}
        speed={2000}
        slidesPerView={5}
        spaceBetween={30}
        allowTouchMove={false}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 3 },
          1024: { slidesPerView: 4 },
          1440: { slidesPerView: 5 },
        }}
      >
        {services.map((service, index) => (
          <SwiperSlide key={index}>
            <div className="Subservices-media-carousel-card">
              <img
                src={service.image}
                alt={service.title}
                className="Subservices-media-carousel-card-img"
              />
              <div className="Subservices-media-carousel-card-content">
                <h3 className="Subservices-media-carousel-card-title">
                  {service.title}
                  <a href={service.link} target="_blank"><span className="Subservices-media-carousel-arrow">↗</span></a>
                </h3>
                <p className="Subservices-media-carousel-card-description">
                  {service.description}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MedicalCareCarousel;
